import { GridCarousel } from '@design-system';
import classNames from 'classnames';
import { FC } from 'react';

import { LinkCard } from '../Cards/LinkCard/LinkCard';
import { TextCard } from '../Cards/TextCard/TextCard';

interface Props extends GridBlok {
  onLinkClick?: (href: string, title?: string) => void;
}

export const StoryblokGrid: FC<Props> = ({
  desktop,
  items,
  mobile,
  onLinkClick,
  tablet,
}) => {
  const component = (blok: GridBlok['items'][0]) => {
    switch (blok.component) {
      case 'textCard':
        return <TextCard key={blok._uid} {...(blok as TextCardBlok)} />;
      case 'linkCard': {
        const card = blok as LinkCardBlok;
        return (
          <LinkCard
            key={blok._uid}
            footerIcon={card.footerIcon}
            footerText={card.footerText}
            href={card.url?.cached_url}
            onClick={onLinkClick}
            target={card.tab ? '_blank' : 'self'}
            title={card.title}
          />
        );
      }
      default:
        return null;
    }
  };

  return (
    <GridCarousel
      gridCols={4}
      items={items.map((item) => (
        <div
          key={item._uid}
          className={classNames(
            mobile && 'col-[span_var(--col-span-sm)_/_span_var(--col-span-sm)]',
            tablet &&
              'md:col-[span_var(--col-span-md)_/_span_var(--col-span-md)]',
            desktop &&
              'lg:col-[span_var(--col-span-lg)_/_span_var(--col-span-lg)]',
          )}
          style={
            {
              '--col-span-sm': mobile,
              '--col-span-md': tablet,
              '--col-span-lg': desktop,
            } as React.CSSProperties
          }
        >
          {component(item)}
        </div>
      ))}
    />
  );
};
